module.exports = __webpack_public_path__ + "media/country_flags/bt-190cc65b.png";